export const APP_NAME = "ZenTrack";

export const APP_WINDOW_TITLE = `${APP_NAME} Desktop`;

export const DESKTOP_ROUTES = [
  "/overview",
  "/clients",
  "/history",
  "/reports",
  "/settings",
  "/tray",
] as const;

export type DesktopRoute = (typeof DESKTOP_ROUTES)[number];

export interface RouteDefinition {
  href: Exclude<DesktopRoute, "/tray">;
  label: string;
  shortLabel: string;
  description: string;
}

export const PRIMARY_ROUTES: RouteDefinition[] = [
  {
    href: "/overview",
    label: "Overview",
    shortLabel: "Home",
    description: "Run the timer, restore an active session, and review recent work.",
  },
  {
    href: "/clients",
    label: "Clients",
    shortLabel: "Clients",
    description: "Manage clients and projects with deletion rules that protect tracked data.",
  },
  {
    // Label renamed History → Timeline; the href stays "/history" so saved
    // lastRoute values from older builds keep restoring without a migration.
    href: "/history",
    label: "Timeline",
    shortLabel: "Timeline",
    description: "See tracked time on a weekly calendar or as a day-by-day list.",
  },
  {
    href: "/reports",
    label: "Reports",
    shortLabel: "Reports",
    description: "Scan totals and export a flat CSV.",
  },
  {
    href: "/settings",
    label: "Settings",
    shortLabel: "Settings",
    description: "Configure session behavior and idle detection.",
  },
];

export const DEFAULT_ROUTE: RouteDefinition["href"] = "/overview";

export const SETTINGS_STORE_KEY = "zentrack.desktop.settings";

export const EXPORT_FILENAME_PREFIX = "zentrack-export";

export function buildExportFileName(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${EXPORT_FILENAME_PREFIX}-${year}-${month}-${day}.csv`;
}
